module.exports = __webpack_public_path__ + "img/ctrl-ising-stub-mid-0.f8be09d9.svg";